import { derived, writable } from 'svelte/store';
export const builderSwiper = writable(null);
export const builderIndices = writable({
    activeIndex: 0,
    itemIndex: null,
    realIndex: 0,
    isEnd: false
});
export const builderSlides = writable([]);
export const builderItems = writable(new Map());
export const builderSummaryItems = derived([builderSwiper, builderSlides, builderItems], ([swiper, slides, items]) => {
    if (!swiper) {
        return [];
    }
    if (swiper.slides) {
        swiper.updateSlides();
    }
    return slides
        .flatMap((slide) => {
        const page = swiper.slides?.indexOf(slide) || 0;
        const pageItems = items.get(slide);
        return pageItems.map(({ title, value }, index) => {
            return { title, value, page, index };
        });
    })
        .sort((a, b) => a.page - b.page || a.index - b.index)
        .map((item) => {
        const { index, ...rest } = item;
        return rest;
    });
});
